import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MetalRateStrip from '../components/MetalRateStrip';
import OperatingLayer from '../components/OperatingLayer';
import HowJmiWorks from '../components/HowJmiWorks';
import OrderPipeline from '../components/OrderPipeline';
import OnboardingModal from '../components/OnboardingModal';

const HowItWorksPage = () => {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authModalRole, setAuthModalRole] = useState('buyer');

  const openAuth = (role) => {
    setAuthModalRole(role);
    setAuthModalOpen(true);
  };

  return (
    <div className="app-wrapper">
      <MetalRateStrip />
      <Navbar onOpenAuthModal={openAuth} />

      <main style={{ paddingBottom: '60px' }}>
        <div className="jmi-container" style={{ paddingTop: '60px', textAlign: 'center' }}>
          <div className="section-label">THE ARCHITECTURE OF TRUST</div>
          <h1 className="section-title">
            How JMI Powers the <span className="gold-gradient-text">B2B Jewellery Ecosystem</span>
          </h1>
          <p className="section-subtitle">
            An in-depth look at the governed operating layer, physical assay audits, insured transit logistics,
            and automated escrow settlement.
          </p>
        </div>

        {/* Operating Layer Core */}
        <OperatingLayer />

        {/* 5-Step Order Flow */}
        <HowJmiWorks />

        {/* 8-Stage Order Custody Stepper */}
        <section style={{ padding: '60px 0' }}>
          <div className="jmi-container">
            <div className="section-header-center">
              <div className="section-label">CUSTODY STEPPER</div>
              <h2 className="section-title">
                Physical Custody <span className="gold-gradient-text">Verification Protocol</span>
              </h2>
            </div>
            <OrderPipeline />
          </div>
        </section>
      </main>

      <Footer onOpenAuthModal={openAuth} />
      <OnboardingModal 
        isOpen={authModalOpen} 
        onClose={() => setAuthModalOpen(false)} 
        initialRole={authModalRole} 
      />
    </div>
  );
};

export default HowItWorksPage;
